export class SlotStatus {
  static NEW = "new";
  static ONHOLD = "onHold";
  static LIMITEDQUANTITY = "limitedQuantity";
  static FULLYBOOKED = "fullyBooked";
  static NOTAVAILABLE = "notAvailable";

  static SlotStatusList = [
    { key: SlotStatus.NEW, value: "New" },
    { key: SlotStatus.ONHOLD, value: "On Hold" },
    { key: SlotStatus.LIMITEDQUANTITY, value: "Limited Quantity" },
    { key: SlotStatus.FULLYBOOKED, value: "Fully Booked" },
    { key: SlotStatus.NOTAVAILABLE, value: "Not Available" },
  ];

  static getStatusValue = (key) => {
    return (
      SlotStatus.SlotStatusList.find((item) => item.key === key)?.value ??
      "Status Not Found"
    );
  };
}
